import React, { useMemo, useState } from "react";
import { useGetRecentDataBatched } from "api/api-hooks/datasets-hooks";
import { v4 as uuidv4 } from "uuid";
import UniversalDatasetTableRow from "./UniversalDatasetTableRow";
import UniversalDatasetTableHeaderRow from "./UniversalDatasetTableHeaderRow";
import {
  findUniversalTableRowIdentifiers,
  getUniversalTableDatasetValues,
} from "./universal-dataset-table-utils";
import "./UniversalDatasetTable.scss";
import { IUniversalDatasetTableConfig } from "./UniversalDatasetTableTypes";

export default function UniversalDatasetTable(props: IUniversalDatasetTableConfig) {
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const datasetIds = useMemo(() => getUniversalTableDatasetValues(props.rows), [props.rows]);

  const { data: recentData } = useGetRecentDataBatched(datasetIds, {
    count: 1,
    refTime: props.referenceTime && new Date(props.referenceTime).toISOString(),
    options: {
      refetchInterval: props.updateFrequency ? props.updateFrequency * 1000 : 0,
    },
  });
  const allDatasets = recentData.flatMap(batch => batch?.data ?? []);

  return (
    <div className="main-main-window">
      {props && props.rows.length > 0 && (
        <table className="main-window">
          <thead>
            {props.showColumnHeaders && !props.hideHeader && (
              <UniversalDatasetTableHeaderRow columnsOptions={props.columnsOptions} />
            )}
          </thead>
          <tbody className="universal-table-body">
            {props.rows.map((row, index) => {
              const identifiers = findUniversalTableRowIdentifiers(row);
              const rowData = allDatasets?.filter(ds => identifiers.includes(ds.identifier));

              return (
                <UniversalDatasetTableRow
                  key={uuidv4()}
                  recentData={rowData}
                  rowData={row}
                  columnsOptions={props.columnsOptions}
                  compactMode={props.compactMode}
                  maxAge={props.maxAge}
                  isSelected={selectedRowIndex === index}
                  onClick={() => setSelectedRowIndex(prev => (prev === index ? null : index))}
                />
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
